import React, { useMemo, useState } from 'react';
import { Card, CardContent, Typography, Divider, TextField } from '@mui/material';

const num = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isNaN(n) ? fallback : n;
};

function matchFlatWithConditions(rate, cartTotal) {
  const min = rate.min_price != null ? num(rate.min_price, 0) : 0;
  const max = rate.max_price != null ? num(rate.max_price, Infinity) : Infinity;
  return cartTotal >= min && cartTotal <= max;
}

export default function ShippingRatesPreview({ zones, countryCode = 'SE' }) {
  const [cartTotal, setCartTotal] = useState(0);

  const { visibleRates, isFree } = useMemo(() => {
    const list = [];

    (zones || []).forEach((z) => {
      const rates = z.shippingRates || [];
      rates.forEach((r) => {
        if (matchFlatWithConditions(r, cartTotal)) {
          list.push({
            id: r.id,
            name: r.name || 'Shipping',
            description: r.description || '',
            price: num(r.price, 0),
          });
        }
      });
    });

    if (list.length === 0) {
      return { visibleRates: [], isFree: true };
    }

    list.sort((a, b) => a.price - b.price);
    return { visibleRates: list, isFree: false };
  }, [zones, cartTotal]);

  return (
    <Card variant="outlined" sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Checkout Preview
        </Typography>
        <TextField
          type="number"
          size="small"
          label="Simulated cart total"
          value={cartTotal}
          onChange={(e) => setCartTotal(Number(e.target.value || 0))}
          sx={{ mb: 2 }}
        />
        <Divider sx={{ mb: 2 }} />

        {isFree ? (
          <Typography>Free shipping</Typography>
        ) : (
          visibleRates.map((r) => (
            <div key={r.id || r.name} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <div>
                <div style={{ fontWeight: 600 }}>{r.name}</div>
                {!!r.description && (
                  <div style={{ fontSize: 12, color: '#666' }}>{r.description}</div>
                )}
              </div>
              <div style={{ fontWeight: 600 }}>
                {Number(r.price).toFixed(2)}
              </div>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
}